<template>
  <div dir="ltr" id="tree" ref="tree"></div>
</template>

<script>
import OrgChart from '@balkangraph/orgchart.js'

export default {
  name: 'tree',
  data() {
    return {
      nodes: [],
      id_route: this.$route['params']['id'],

    }
  },
  methods: {
    mytree: function(domEl, x) {
      this.chart = new OrgChart(domEl, {
        editForm: {readOnly: true},
        nodes: x,
        enableSearch: false,
        template: "ana",
        toolbar: {
          zoom: true,
          fit: true,
          expandAll: true,
          fullScreen: true,
          lazyLoading: false,

        },
        layout: OrgChart.layout.tree,
        zoom: {
          initialScale: 0.8,
          maxScale: 1.5,
        },
        nodeBinding: {
          field_1: "title",
          cssClass: 'ss',
        },
      });
    },
    fetchItems() {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow',
      };

      fetch(`${this.base_url}/debts/chart_by_id/${this.id_route}`, requestOptions)
          .then(response => response.json())
          .then(result => {
            if (result.length !== 0) {
              this.nodes = result;
              this.mytree(this.$refs.tree, this.nodes);
            }
          })
          .catch(error => {
          });
    },
  },
  mounted() {
    this.fetchItems();
  },
};
</script>

<style scoped>
.field_1 {
  margin-right: 2vw !important;
}

</style>
